import { Link } from 'react-router-dom';
import type { ReactNode } from 'react';
import { Logo } from './Logo.js';

export function TopBar({ children }: { children?: ReactNode }) {
  return (
    <div className="topbar">
      <Link to="/" className="brand" aria-label="Mania 3D — início">
        <Logo />
      </Link>
      <nav>{children}</nav>
    </div>
  );
}
